import React, { useEffect, useState } from "react";
import { renderError } from "../../../helpers/errors";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";

export const SelectAdmin = ({selectedAdmin, setSelectedAdmin, nullable, labelNullable, nullableValue, pipelineId}) => {
    const [loading, setLoading] = useState(true);

    const [admins, setAdmins] = useState([]);

    useEffect(() => {
        getAdmins();
    }, [pipelineId]);

    const getAdmins = () => {
        setLoading(true);

        // Com pipelineId, lista apenas os usuários com acesso àquele painel —
        // não faz sentido atribuir um card a quem não enxerga o painel.
        const url = pipelineId ? `/list?pipeline_id=${pipelineId}` : `/list`;

        api.get(url).then(res => {
            setAdmins(Array.isArray(res.data.resources) ? res.data.resources : []);
        }).catch(error => {
            renderError(error);
        }).then(() => {
            setLoading(false);
        });
    }

    const baseOptions = createOptions(admins, 'name', 'id');
    const options = nullable === true
        ? [{ label: labelNullable ?? 'Nenhuma opção', value: nullableValue ?? null }, ...baseOptions]
        : baseOptions;

    return (
        <InputSelect
            loading={loading}
            label={`Responsável`}
            options={options}
            value={selectedAdmin}
            change={setSelectedAdmin}
        />
    );
}

export default SelectAdmin;
